import script from "./AlertsAndWarnings.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlertsAndWarnings.vue?vue&type=script&setup=true&lang=ts"

import "./AlertsAndWarnings.vue?vue&type=style&index=0&id=7520e0f1&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7520e0f1"]])

export default __exports__